// extracted by mini-css-extract-plugin
export default {"container":"V04jg","included-in-tariffs":"WLiYj"};